import React, { FC } from "react";
import { ResourceTypeLink } from "@evergis/api";

import { BulkCopyLayersContent } from "./Layers";
import { BulkCopyProjectsContent } from "./Projects";

import { useResourceType } from "../../../../hooks/useResourceType";

import { BulkCopyOptionsProps } from "../../CopyResource/types";

export const BulkCopyDialogContent: FC<BulkCopyOptionsProps> = props => {
  const [resourceType] = useResourceType();

  switch (resourceType) {
    case ResourceTypeLink.Project:
      return <BulkCopyProjectsContent {...props} />;
    case ResourceTypeLink.Layer:
      return <BulkCopyLayersContent {...props} />;
    default:
      return null;
  }
};
